export default __webpack_public_path__ + "static/media/email_2.cd1ad987.svg";